import intersectionObserver from "./intersectionObserver";
import barba from '@barba/core';
import main from "./main";
import { SearchModel } from "./search";
import { scrollToBlock } from "./animation";
var statOffline = false;
var time = .45;
var offlineTimeOut = 25;
window.addEventListener("offline", function (event) {
  cPush.show({
    title: "\u0421\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u0435 \u043F\u043E\u0442\u0435\u0440\u044F\u043D\u043E \u0441 \u0438\u043D\u0442\u0435\u0440\u043D\u0435\u0442\u043E\u043C."
  });
  statOffline = true;
  setTimeout(function () {
    if (statOffline) window.location.href = '/offline';
  }, (offlineTimeOut - 2) * 1000);
});
window.addEventListener("online", function (event) {
  cPush.show({
    title: "\u0421\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u0435 \u0441 \u0438\u043D\u0442\u0435\u0440\u043D\u0435\u0442\u043E\u043C \u0432\u043E\u0441\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D\u043E."
  });
  statOffline = false;
});
var tpl = "<div class=\"__load\"><i class=\"preloader-ring-big\"></i></div>";
export default function transitions() {
  // barba.use(barbaPrefetch);
  barba.init({
    // prefetchIgnore: false,
    // debug: true,
    //preventRunning: true,
    timeout: offlineTimeOut * 1000,
    prevent: function prevent(_ref) {
      var el = _ref.el,
        event = _ref.event,
        href = _ref.href;
      el.onclick = function (e) {
        if (window.location.href === href) {
          e.preventDefault();
          cPush.show({
            text: "Вы на данной странице"
          });
          $(".menu").classList.remove("active");
          $(".hamburger").classList.remove("open");
          // console.log(window.location.href, href);
        }
      };
    },
    requestError: function requestError(trigger, action, url, response) {
      if (action === "click" && response.status && response.status === 404) {
        // barba.go("/404");
        // cPush.show({ title: `${response.status}` });
        console.log("".concat(response.status));
      }
      return false;
    },
    transitions: [{
      name: "default-by-M4Lets",
      // sync: true,
      beforeEnter: function beforeEnter(data) {
        if ($('.review__item__text')) cutText('.review__item__text', 80);
        if (data.next.container.querySelector(".hero") !== null && data.next.container.querySelector(".hero__prevent") === null) {
          data.next.container.querySelector(".hero").classList.add('hidden');
          if (data.next.container.querySelector(".breadcrumbs")) {
            data.next.container.querySelector(".breadcrumbs").insertAdjacentHTML("beforeend", '<i>•</i><div class="hero__return" title="Просмотреть скрытую информацию на странице">Подробнее</div>');
            setTimeout(function () {
              $('.hero__return').addEventListener('click', function (e) {
                $(".hero").classList.remove('hidden');
                $('.hero__return').remove();
                tl.fromTo('.hero', {
                  opacity: 0
                }, {
                  duration: .2,
                  opacity: 1
                });
                scrollToBlock();
              });
            }, time);
          }
        }
        intersectionObserver();
        setTimeout(function () {
          return window.scrollTo({
            top: 0
          });
        }, 100);
        if (typeof ym === "function") {
          ym(49104928, "hit", window.location.pathname);
          ga("set", "page", window.location.pathname);
          ga("send", "pageview");
          // VK.Retargeting.Hit();
        }
      },
      beforeLeave: function beforeLeave() {
        $(".menu").classList.remove("active");
        $(".hamburger").classList.remove("open");
        new SearchModel().close();
        soundPush('/sound/ps5/ps5-selection-button.mp3');
      },
      leave: function leave(data) {
        // sessionStorage.setItem(`data-scroll-for-${data.current.url.path}`, window.pageYOffset);
        var done = this.async();
        var tl = gsap.timeline();
        tl.to(data.current.container, {
          duration: time,
          opacity: 0,
          onComplete: done
        }, 0);
        $("body").insertAdjacentHTML("beforeend", tpl);
        setTimeout(function () {
          if ($('.__load ')) tl.to('.__load', {
            duration: time,
            opacity: 1
          });
        }, 1000);
      },
      enter: function enter(data) {
        var tl = gsap.timeline();
        tl.fromTo(data.next.container, {
          opacity: 0
        }, {
          duration: time,
          opacity: 1
        });
        if ($('.__load ')) $('.__load').remove();
        setTimeout(function () {
          main();
        }, 500);
      }
    }]
  });
}